<div class="button--more">
    <button (click)="onMoreClicked()" class="bdo-nobutton">
        <div class="icon__more">
            <bdo-svg name="icon-more" styling="icon__more"></bdo-svg>
        </div>
        <span class="bold">{{label}}</span>
    </button>
</div>